module.exports = __webpack_public_path__ + "static/media/krypton-logo.ecb9f09c.png";